import React from "react";
import styled from "styled-components";
import Menu from "./Menu";
import ContentBlock from "./ContentBlock";
import Container from "./Container";

const HeaderWrapper = styled.div`
  width: 100%;
  background-image:url('https://images.unsplash.com/photo-1521623692445-8d613b81e3ef?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=1b48a803a1d5aeecf14db41057ffff6c&auto=format&fit=crop&w=3954&q=80');
  background-size: cover;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  position: relative;
  height: 17.5em
  
  @media screen and (min-width: ${props => props.theme.responsive.small}) { 
    height: 23em; 
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) { 
    height: 31em;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: .8;
    background-color: ${props => props.theme.colors.black};
    z-index: 0;
  }

  > * {
    z-index: 1;
    &:first-child {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 2;
    }
  }
`;

const HeaderSmall = props => {
  return (
    <HeaderWrapper
      style={{
        backgroundImage: `url(${
          props.header[0].node.backgroundImageSmall.sizes.src
          })`
      }}
    >
      <Menu
        home={props.header[0].node.home}
        about={props.header[0].node.about}
        features={props.header[0].node.features}
        contact={props.header[0].node.contact}
        login={props.header[0].node.login}
        loginLink={props.header[0].node.loginLink}
        loginIcon={props.header[0].node.loginIcon}
        aboutDetailLinks={props.aboutDetailLinks}
        aboutActive={props.aboutActive}
      />

      <Container inSmallHeader={true}>
        <ContentBlock
          fullWidth={true}
          largeTitle={true}
          diapositive={true}
          inSmallHeader={true}
          title={props.title}
        />
      </Container>
    </HeaderWrapper>
  );
};

export default HeaderSmall;



// WEBPACK FOOTER //
// ./src/components/HeaderSmall.js